/* Shadow & Specter — brand motion behaviour.
   Added 2026-08-04. No dependencies, ~1KB.

   Three jobs:
   1. Mark <html> as js-capable so CSS can safely hide reveal targets.
   2. Fade sections up once as they enter the viewport (IntersectionObserver).
   3. Stamp the newsletter button on submit.

   Bails out entirely under prefers-reduced-motion.
*/
(function () {
  'use strict';

  var reduced =
    window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (reduced || !('IntersectionObserver' in window)) {
    // Leave everything visible and static.
    return;
  }

  document.documentElement.classList.add('js');

  function initReveals() {
    // Reveal the top-level content blocks of each homepage/collection section.
    var targets = document.querySelectorAll('.ss-reveal');
    if (!targets.length) return;

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('ss-reveal--in');
          io.unobserve(entry.target); // once only
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
    );

    targets.forEach(function (el, i) {
      // Stagger siblings ~80ms apart, capped so nothing waits too long.
      var delay = Math.min(i % 4, 3) * 80;
      el.style.setProperty('--ss-reveal-delay', delay + 'ms');
      io.observe(el);
    });
  }

  function initSeal() {
    var forms = document.querySelectorAll('.newsletter-form');
    Array.prototype.forEach.call(forms, function (form) {
      form.addEventListener('submit', function () {
        var btn = form.querySelector('button[type="submit"]');
        if (!btn) return;
        btn.classList.remove('ss-seal-press');
        // reflow so the animation can replay
        void btn.offsetWidth;
        btn.classList.add('ss-seal-press');
      });
    });
  }

  function ready(fn) {
    if (document.readyState !== 'loading') {
      fn();
    } else {
      document.addEventListener('DOMContentLoaded', fn);
    }
  }

  ready(function () {
    initReveals();
    initSeal();
  });
})();
